import React, { FormEvent, useEffect, useState } from "react";
import {
  customStyles,
  ModalA,
  ModalButton,
  ModalClose,
  ModalContentA,
  ModalContentButton,
  ModalFormControl,
  ModalFormControlLabel,
  ModalFormLabel,
  ModalFormularioDiv,
  ModalH2,
  ModalInputLabel,
  ModalOutlinedInput,
  ModalRadio,
  ModalRadioGroup,
} from "./styles";
import Modal from "react-modal";
import { linkDeepaffex } from "../../../Services/Auth";
import { IHealthPlace } from "../../../Services/Interfaces";
import { FormHelperText } from "@mui/material";
import VirtualKeyboard from "./VirtualKeyboard";
import { FaKeyboard } from "react-icons/fa";

interface ModalProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  modalIsOpen: boolean;
}

const ModalComponentMedicao: React.FC<ModalProps> = ({ setIsOpen, modalIsOpen }) => {
  Modal.setAppElement("#root");

  const [customer, setCustomer] = useState("");
  const [service, setService] = useState("");
  const [age, setAge] = useState<string>("");
  const [height, setHeight] = useState<string>("");
  const [showErrorHeight, setShowErrorHeight] = useState(false);
  const [weight, setWeight] = useState<string>("");
  const [showErrorWeight, setShowErrorWeight] = useState(false);

  const [gender, setGender] = useState("");
  const [smoking, setSmoking] = useState("");
  const [bloodpressuremedication, setBloodpressuremedication] = useState("");
  const [diabetes, setDiabetes] = useState("");

  const [showKeyboard, setShowKeyboard] = useState(false);
  const [activeField, setActiveField] = useState<"age" | "height" | "weight" | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const HealthPlaceJSON = localStorage.getItem("HealthPlaceDados");
    if (HealthPlaceJSON) {
      const HealthPlaceDados = JSON.parse(HealthPlaceJSON) as IHealthPlace;
      setCustomer(HealthPlaceDados.customer.deepAffexCallbackId);
      setService(HealthPlaceDados.service.deepAffexCallbackId);
    }

    // Verificar se há parâmetros da URL para preencher automaticamente
    const urlParams = new URLSearchParams(window.location.search);
    const age = urlParams.get('age');
    const height = urlParams.get('height');
    const weight = urlParams.get('weight');
    const gender = urlParams.get('gender');
    const smoking = urlParams.get('smoking');
    const bloodpressuremedication = urlParams.get('bloodpressuremedication');
    const diabetes = urlParams.get('diabetes');

    if (age) setAge(age);
    if (height) setHeight(height);
    if (weight) setWeight(weight);
    if (gender) setGender(gender);
    if (smoking !== null) setSmoking(smoking);
    if (bloodpressuremedication !== null) setBloodpressuremedication(bloodpressuremedication);
    if (diabetes !== null) setDiabetes(diabetes);
  }, []);

  // Executar medição automaticamente se todos os dados estiverem preenchidos e válidos
  useEffect(() => {
    if (modalIsOpen && customer && service && age && height && weight && gender && smoking && bloodpressuremedication && diabetes) {
      // Validar se todos os dados são válidos
      const ageNum = parseInt(age);
      const heightNum = parseInt(height);
      const weightNum = parseInt(weight);
      
      if (ageNum >= 13 && ageNum <= 120 && 
          heightNum >= 68 && heightNum <= 290 && 
          weightNum >= 25 && weightNum <= 199 &&
          ['male', 'female'].includes(gender) &&
          ['0', '1'].includes(smoking) &&
          ['0', '1'].includes(bloodpressuremedication) &&
          ['0', 'type1', 'type2'].includes(diabetes)) {
        
        // Aguardar um pouco para garantir que todos os dados foram carregados
        const timer = setTimeout(() => {
          executeMeasurement();
        }, 1000);
        
        return () => clearTimeout(timer);
      }
    }
  }, [modalIsOpen, customer, service, age, height, weight, gender, smoking, bloodpressuremedication, diabetes]);

  function closeModal() {
    setCustomer("");
    setService("");
    setAge("");
    setHeight("");
    setWeight("");
    setGender("");
    setSmoking("");
    setBloodpressuremedication("");
    setDiabetes("");
    setIsLoading(false);
    setIsOpen(false);
  }

  const envioDadosMedicao = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    await executeMeasurement();
  };

  const executeMeasurement = async () => {
    try {
      const path = await linkDeepaffex(
        JSON.stringify({
          identifier: `${customer}--${service}`,
          age,
          height,
          weight,
          gender,
          smoking,
          bloodpressuremedication,
          diabetes,
        })
      );
      if (path) {
        window.location.href = path.toString();
      }
    } catch (error) {
      console.error('Erro ao executar medição:', error);
      setIsLoading(false);
    }
  };

  function handleInputClick(field: "age" | "height" | "weight") {
    setActiveField(field);
    setShowKeyboard(true);
  }

  function handleKeyboardInput(value: string) {
    const numericValue = value.replace(/[^0-9]/g, '');
    
    if (activeField === "age") {
      if (numericValue === '' || parseInt(numericValue) <= 115) {
        setAge(numericValue);
      }
    } else if (activeField === "height") {
      if (numericValue === '' || parseInt(numericValue) <= 290) {
        setHeight(numericValue);
      }
    } else if (activeField === "weight") {
      if (numericValue === '' || parseInt(numericValue) <= 600) {
        setWeight(numericValue);
      }
    }
  }

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Dados pre medição">
      <ModalContentA>
        <ModalA onClick={closeModal}>
          <ModalClose />
        </ModalA>
      </ModalContentA>
      <ModalH2>Dados pre medição</ModalH2>
      <ModalFormularioDiv onSubmit={envioDadosMedicao}>
        {/* Campo Idade */}
        <ModalFormControl variant="outlined">
          <ModalInputLabel htmlFor="age">Idade</ModalInputLabel>
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <ModalOutlinedInput
                id="age"
                type="text"
                inputMode="numeric"
                inputProps={{ pattern: "[0-9]*" }}
                label="Idade"
                required
                value={age}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9]/g, '');
                  if (numericValue === '' || parseInt(numericValue) <= 115) {
                    setAge(numericValue);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === '.' || e.key === ',' || e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
                    e.preventDefault();
                  }
                }}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={() => handleInputClick("age")}
                style={{ border: "none", background: "transparent", cursor: "pointer", marginLeft: "8px" }}
              >
                <FaKeyboard size={20} />
              </button>
            </div>
            {showKeyboard && activeField === "age" && (
              <VirtualKeyboard onChange={handleKeyboardInput} onClose={() => setShowKeyboard(false)} currentValue={age} />
            )}
          </div>
        </ModalFormControl>

        {/* Campo Altura */}
        <ModalFormControl variant="outlined" error={showErrorHeight}>
          <ModalInputLabel htmlFor="height">Altura (centímetros)</ModalInputLabel>
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <ModalOutlinedInput
                id="height"
                type="text"
                inputMode="numeric"
                inputProps={{ pattern: "[0-9]*" }}
                label="Altura (centímetros)"
                required
                value={height}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9]/g, '');
                  if (numericValue === '' || parseInt(numericValue) <= 290) {
                    setHeight(numericValue);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === '.' || e.key === ',' || e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
                    e.preventDefault();
                  }
                }}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={() => handleInputClick("height")}
                style={{ border: "none", background: "transparent", cursor: "pointer", marginLeft: "8px" }}
              >
                <FaKeyboard size={20} />
              </button>
            </div>
            {showErrorHeight && <FormHelperText>Valor não pode ser maior que 251 cm</FormHelperText>}
            {showKeyboard && activeField === "height" && (
              <VirtualKeyboard onChange={handleKeyboardInput} onClose={() => setShowKeyboard(false)} currentValue={height} />
            )}
          </div>
        </ModalFormControl>

        {/* Campo Peso */}
        <ModalFormControl variant="outlined" error={showErrorWeight}>
          <ModalInputLabel htmlFor="weight">Peso</ModalInputLabel>
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <ModalOutlinedInput
                id="weight"
                type="text"
                inputMode="numeric"
                inputProps={{ pattern: "[0-9]*" }}
                label="Peso"
                required
                value={weight}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9]/g, '');
                  if (numericValue === '' || parseInt(numericValue) <= 600) {
                    setWeight(numericValue);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === '.' || e.key === ',' || e.key === '-' || e.key === '+' || e.key === 'e' || e.key === 'E') {
                    e.preventDefault();
                  }
                }}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={() => handleInputClick("weight")}
                style={{ border: "none", background: "transparent", cursor: "pointer", marginLeft: "8px" }}
              >
                <FaKeyboard size={20} />
              </button>
            </div>
            {showErrorWeight && <FormHelperText>Valor não pode ser maior que 250 Kg</FormHelperText>}
            {showKeyboard && activeField === "weight" && (
              <VirtualKeyboard onChange={handleKeyboardInput} onClose={() => setShowKeyboard(false)} currentValue={weight} />
            )}
          </div>
        </ModalFormControl>

        {/* Outras informações do formulário */}
        <ModalFormControl>
          <ModalFormLabel>Gênero</ModalFormLabel>
          <ModalRadioGroup row value={gender} onChange={(e) => setGender(e.target.value)}>
            <ModalFormControlLabel value="male" control={<ModalRadio required />} label="Masculino" />
            <ModalFormControlLabel value="female" control={<ModalRadio required />} label="Feminino" />
          </ModalRadioGroup>
        </ModalFormControl>

        <ModalFormControl>
          <ModalFormLabel>Fumante?</ModalFormLabel>
          <ModalRadioGroup row value={smoking} onChange={(e) => setSmoking(e.target.value)}>
            <ModalFormControlLabel value="1" control={<ModalRadio required />} label="Sim" />
            <ModalFormControlLabel value="0" control={<ModalRadio required />} label="Não" />
          </ModalRadioGroup>
        </ModalFormControl>

        <ModalFormControl>
          <ModalFormLabel>Utiliza medicamento para pressão?</ModalFormLabel>
          <ModalRadioGroup row value={bloodpressuremedication} onChange={(e) => setBloodpressuremedication(e.target.value)}>
            <ModalFormControlLabel value="1" control={<ModalRadio required />} label="Sim" />
            <ModalFormControlLabel value="0" control={<ModalRadio required />} label="Não" />
          </ModalRadioGroup>
        </ModalFormControl>

        <ModalFormControl>
          <ModalFormLabel>Diabetes?</ModalFormLabel>
          <ModalRadioGroup row value={diabetes} onChange={(e) => setDiabetes(e.target.value)}>
            <ModalFormControlLabel value="type1" control={<ModalRadio required />} label="Tipo 1" />
            <ModalFormControlLabel value="type2" control={<ModalRadio required />} label="Tipo 2" />
            <ModalFormControlLabel value="0" control={<ModalRadio required />} label="Não" />
          </ModalRadioGroup>
        </ModalFormControl>

        <ModalContentButton>
          <ModalButton 
            title="Medir" 
            disabled={isLoading}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              gap: '10px'
            }}
          >
            {isLoading ? (
              <>
                <div style={{
                  border: '2px solid #ffffff',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  width: '16px',
                  height: '16px',
                  animation: 'spin 1s linear infinite'
                }}></div>
                Processando...
              </>
            ) : (
              'Medir'
            )}
          </ModalButton>
        </ModalContentButton>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </ModalFormularioDiv>
    </Modal>
  );
};

export default ModalComponentMedicao;
